import { render, staticRenderFns } from "./RelatedAssets.vue?vue&type=template&id=17a09134"
import script from "./RelatedAssets.vue?vue&type=script&lang=js"
export * from "./RelatedAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports